import { render } from "./MemberRegistrationForm.vue?vue&type=template&id=99bff61a&scoped=true&ts=true"
import script from "./MemberRegistrationForm.vue?vue&type=script&lang=ts"
export * from "./MemberRegistrationForm.vue?vue&type=script&lang=ts"

import "./MemberRegistrationForm.vue?vue&type=style&index=0&id=99bff61a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99bff61a"]])

export default __exports__